import OrderIcon from '@mui/icons-material/AttachMoney';
import OrderManagement from './OrderManagement';


export default {
    list: OrderManagement,
    icon: OrderIcon,
    recordRepresentation: 'reference',
};
